import { Modal, Typography } from "antd";
import { useTranslate } from "hooks/useTranslate/";
import { useThemeData } from "../hooks/useThemeData";
import { useUpdateTheme } from "../hooks/useThemeApi";
import type { ThemeResponse } from "../hooks/useThemeApi";

type PublishThemeModalProps = {
  open: boolean;
  onClose: () => void;
  theme: ThemeResponse;
  onPublished: () => void;
};

export const PublishThemeModal = ({
  open,
  onClose,
  theme,
  onPublished,
}: PublishThemeModalProps) => {
  const t = useTranslate();
  const { organizationId } = useThemeData();
  const { mutateAsync, isPending } = useUpdateTheme(organizationId);

  const handlePublish = async () => {
    await mutateAsync({
      themeId: theme.id,
      data: { public: true },
    });
    onClose();
    onPublished();
  };

  return (
    <Modal
      title={t("media.themeEditor.publishModal.title")}
      open={open}
      onOk={() => void handlePublish()}
      onCancel={onClose}
      okText={t("media.themeEditor.publishModal.confirm")}
      cancelText={t("buttons.cancel")}
      okButtonProps={{ danger: true }}
      confirmLoading={isPending}
    >
      <Typography.Paragraph>
        {t("media.themeEditor.publishModal.warning")}
      </Typography.Paragraph>
      <Typography.Text strong>{theme.name}</Typography.Text>
    </Modal>
  );
};
